import React from 'react'

import {ThemeModalDrawer, ThemeModalDrawerSection} from '../drawer'
import DetailsList from './DetailsList'
import {classes as authClasses} from './DetailsMobileAuth.classes'
import {classes as styles} from './styles'
import type {Props} from './types'

const DetailsMobileAuth: React.FC<Props> = ({onClose, sections, title}) => {
  return (
    <ThemeModalDrawer onClose={onClose}>
      <ThemeModalDrawerSection fullHeight>
        <div className={styles.detailsMobile} data-e2e="details-modal-content">
          <div className={authClasses.title}>{title}</div>
          <DetailsList sections={sections} />
        </div>
      </ThemeModalDrawerSection>
    </ThemeModalDrawer>
  )
}

export default DetailsMobileAuth
